/* TWRD: View all card in the home rails, a photo stack (Oliver 2026-10-25/26).
   The back cards stay still. The front card holds every photo as a layer and
   crossfades them with the site's blur dissolve, so nothing jumps or reshuffles.
   Runs only while the card is on screen; reduced motion keeps the first photo.

   TWRD perf (W2): cards 2+ arrive with data-srcset/data-src (see
   sections/section-collection.liquid). They are restored, together with their
   front-card layer clones, when the tile comes near the screen, or at idle
   4 s after window load, whichever is first. "Near" is two checks: the tile is within 600px of
   the viewport vertically, and within 1250px of the rail's visible area
   horizontally (Chrome's own lazy-load distance on a fast network). A layer
   only becomes the front photo once its file has loaded, so a slow network
   never shows an empty frame. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP_MS = 3200;
  var FADE_MS = 1600;
  var NEAR_VERTICAL = 600; /* px above/below the viewport */
  var NEAR_HORIZONTAL = 1250; /* px left/right of the rail's visible area */
  var AFTER_LOAD_MS = 4000; /* idle fallback delay after window load */
  var IDLE_TIMEOUT_MS = 2000;
  var DEFERRED = 'img[data-src], img[data-srcset]';
  var pageLoaded = document.readyState === 'complete';
  var pendingBoxes = [];

  function moveAttr(el, from, to) {
    var value = el.getAttribute(from);
    if (value === null) return;
    el.setAttribute(to, value);
    el.removeAttribute(from);
  }

  /* Restores every deferred image in the box: the originals and the layer clones. */
  function restoreImages(box) {
    if (box.dataset.twrdStackRestored) return;
    box.dataset.twrdStackRestored = '1';
    var imgs = box.querySelectorAll(DEFERRED);
    for (var i = 0; i < imgs.length; i++) {
      /* Eager: the box is already near, so the file must not wait for the native lazy distance. */
      imgs[i].loading = 'eager';
      moveAttr(imgs[i], 'data-srcset', 'srcset');
      moveAttr(imgs[i], 'data-src', 'src');
    }
  }

  function isReady(img) {
    return Boolean(img && img.getAttribute('src') && img.complete && img.naturalWidth > 0);
  }

  /* Nearest ancestor that scrolls horizontally (the rail track). */
  function findScroller(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var overflowX = window.getComputedStyle(node).overflowX;
      if (overflowX === 'auto' || overflowX === 'scroll') return node;
      node = node.parentElement;
    }
    return null;
  }

  /* Geometry check on any scroll (page or rail, caught in the capture phase),
     one per frame. No IntersectionObserver: the rail scroller clips a viewport
     observer. The scroller is looked up on each check, because the rail CSS
     can arrive after this script runs. */
  function watchNear(box) {
    if (!box.querySelector(DEFERRED)) return;
    if (pageLoaded) { restoreImages(box); return; }

    var queued = false;
    var done = function () {
      restoreImages(box);
      document.removeEventListener('scroll', schedule, true);
      window.removeEventListener('resize', schedule);
    };
    var test = function () {
      queued = false;
      /* Skip while the section is skipped by content-visibility: reading its geometry would force its layout. */
      if (box.checkVisibility && !box.checkVisibility({ contentVisibilityAuto: true })) return;
      var r = box.getBoundingClientRect();
      if (!r.width && !r.height) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom < -NEAR_VERTICAL || r.top > vh + NEAR_VERTICAL) return;
      var scroller = findScroller(box);
      var s = scroller ? scroller.getBoundingClientRect() : { left: 0, right: window.innerWidth };
      if (r.right < s.left - NEAR_HORIZONTAL || r.left > s.right + NEAR_HORIZONTAL) return;
      done();
    };
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(test);
    }
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    pendingBoxes.push(done);
    schedule();
  }

  function init(box) {
    if (box.dataset.twrdStackReady) return;
    box.dataset.twrdStackReady = '1';
    var cards = Array.prototype.slice.call(box.querySelectorAll('.twrd-hrail__polaroid'));
    if (!cards.length) return;
    cards.forEach(function (c, i) { c.setAttribute('data-pos', String(Math.min(i, 3))); if (i > 3) c.hidden = true; });
    var front = cards[0];
    var imgs = cards.map(function (c) { return c.querySelector('img'); }).filter(Boolean);
    if (reduce || imgs.length < 2) { watchNear(box); return; }

    /* Front card gets one layer per photo. Clones keep data-src until restoreImages(). */
    var layers = imgs.map(function (img, i) {
      var l = i === 0 ? img : img.cloneNode(true);
      l.classList.add('twrd-hrail__layer');
      l.loading = 'lazy';
      if (i > 0) front.appendChild(l);
      if (i === 0) l.classList.add('is-active');
      return l;
    });
    watchNear(box);
    var stack = box.querySelector('.twrd-hrail__stack');
    var current = 0;
    var timer = null;

    /* Next layer whose file has loaded; -1 when none is ready yet (this tick is skipped). */
    var nextReady = function () {
      for (var k = 1; k < layers.length; k++) {
        var idx = (current + k) % layers.length;
        if (isReady(layers[idx])) return idx;
      }
      return -1;
    };

    var step = function () {
      var target = nextReady();
      if (target < 0) return;
      var prev = layers[current];
      current = target;
      var next = layers[current];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      next.classList.add('is-active');
      if (stack) { stack.classList.remove('is-hazing'); void stack.offsetWidth; stack.classList.add('is-hazing'); }
      setTimeout(function () {
        prev.classList.remove('is-leaving');
        if (stack) stack.classList.remove('is-hazing');
      }, FADE_MS);
    };
    var start = function () { if (!timer) timer = setInterval(step, STEP_MS); };
    var stop = function () { clearInterval(timer); timer = null; };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) restoreImages(box); /* safety net: on screen is always near */
          if (e.isIntersecting && !document.hidden) start(); else stop();
        });
      }, { threshold: 0.25 }).observe(box);
    } else { restoreImages(box); start(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  }
  function scan() { document.querySelectorAll('[data-twrd-stack]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  /* Fallback, well after load: a tile that is still offscreen sideways gets its
     photos 4 s after window load, at idle, so they are ready before a typical
     swipe without competing with the first screen. */
  window.addEventListener('load', function () {
    pageLoaded = true;
    setTimeout(function () {
      var run = function () {
        pendingBoxes.forEach(function (done) { done(); });
        pendingBoxes = [];
      };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });
      else run();
    }, AFTER_LOAD_MS);
  }, { once: true });
})();
